import { state } from './state.js';

/* ═══════════════════════════════════════════
   § 5. CRM PAINT ENGINE
   ═══════════════════════════════════════════ */

export function paintScene(isInstant = false) {
  state.crmData.forEach(p => {
    if (!p.MatName || !state.plotMeshes.has(p.MatName)) return;

    const meshes = state.plotMeshes.get(p.MatName);
    let clr = null;
    let isSelected = state.selectedPlotId && p.Plot_ID === state.selectedPlotId;

    if (state.showStatus && p.status_id) clr = state.STATUS_CLR[p.status_id];
    else if (state.showSector && p.sector_id) clr = state.sectorColorMap[p.sector_id];

    meshes.forEach(m => {
      const targetColor     = isSelected ? '#ffffff' : (clr || (state.originalColors.get(m.uuid) || '#ffffff'));
      const targetEmissive  = isSelected ? '#ffffff' : (clr ? clr : '#000000');
      const targetIntensity = isSelected ? 1.0 : (clr ? 0.2 : 0);
      const targetMetalness = isSelected ? 0.1 : 0.1;
      const targetRoughness = isSelected ? 0.8 : 0.8;

      if (isInstant) {
        m.material.color.set(targetColor);
        if (m.material.emissive) {
          m.material.emissive.set(targetEmissive);
          m.material.emissiveIntensity = targetIntensity;
        }
        if (m.material.metalness !== undefined) m.material.metalness = targetMetalness;
        if (m.material.roughness !== undefined) m.material.roughness = targetRoughness;
        m.material.needsUpdate = true;
      } else {
        // Slow wave effect based on precomputed distance
        setTimeout(() => {
          m.material.color.set(targetColor);
          if (m.material.emissive) {
            m.material.emissive.set(targetEmissive);
            m.material.emissiveIntensity = targetIntensity;
          }
          if (m.material.metalness !== undefined) m.material.metalness = targetMetalness;
          if (m.material.roughness !== undefined) m.material.roughness = targetRoughness;
          m.material.needsUpdate = true;
        }, (m.userData.dist || 0) * 8);
      }
    });
  });
}
